module.exports = __webpack_public_path__ + "img/p-03.e3a15b8b.webp";